import api from "src/features/auth/axiosConfig";

const PRINT_CONFIG_API = "/app/pos/v2/print-layouts";

export const fetchPrintConfig = async () => {
  try {
    const response = await api.get(PRINT_CONFIG_API);
    const data = response.data;
    return data;
  } catch (error) {
    console.error("Error fetching print config:", error);
    throw error;
  }
};

export const postPrintConfig = async (configData: any) => {
  try {
    const response = await api.post(`${PRINT_CONFIG_API}`, configData);
    const data = response.data;
    return data;
  } catch (error) {
    console.error("Error updating print config:", error);
    throw error;
  }
};

export const updatePrintConfig = async (id: string, configData: any) => {
  try {
    const response = await api.put(`${PRINT_CONFIG_API}/${id}`, configData);
    const data = response.data;
    return data;
  } catch (error) {
    console.error("Error updating print config:", error);
    throw error;
  }
};

export const deletePrintConfig = async (id: string) => {
  try {
    const response = await api.delete(`${PRINT_CONFIG_API}/${id}`);
    const data = response.data;
    return data;
  } catch (error) {
    console.error("Error updating print config:", error);
    throw error;
  }
};
